var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"palette",style:(_vm.style)},_vm._l((_vm.steps),function(step,index){return _c('div',{key:index,staticClass:"step",style:({ background: step })})}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }